import { Pipe, PipeTransform } from '@angular/core';
import { TimeFormatPipe } from './time-format.pipe';

const SLOT_TYPE_LABELS: Record<string, string> = {
  AM: 'Morning',
  PM: 'Afternoon',
  EV: 'Evening',
};

@Pipe({
  name: 'appointmentSlotLabel',
  standalone: true,
})
export class AppointmentSlotLabelPipe implements PipeTransform {
  constructor(private timeFormatPipe: TimeFormatPipe) {}

  transform(slot: any): string {
    if (!slot) return '';

    const slotType: string | undefined = slot.slotType;
    const start = this.timeFormatPipe.transform(slot.startTime) as string;
    const end = this.timeFormatPipe.transform(slot.endTime) as string;

    if (slotType && SLOT_TYPE_LABELS[slotType]) {
      const label = SLOT_TYPE_LABELS[slotType];
      return start && end ? `${label} (${start} - ${end})` : label;
    }

    if (slot.allDay) return 'All day';

    return `${start} - ${end}`;
  }
}
